var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('PageTitle', [_vm._v("請輸入會員密碼")]), _c('Form', {
    attrs: {
      "action": _vm.submit,
      "after-action": _vm.afterSubmit
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var busy = _ref.busy;
        return [_c('div', {
          staticClass: "s-space-y-3 s-mb-10"
        }, [_c('Input', {
          attrs: {
            "label": "輸入新密碼",
            "type": "password",
            "name": "password",
            "placeholder": "6 - 10 個英文加數字，需區分大小寫",
            "maxlength": "10",
            "required": ""
          },
          model: {
            value: _vm.password,
            callback: function callback($$v) {
              _vm.password = $$v;
            },
            expression: "password"
          }
        }), _c('Input', {
          attrs: {
            "label": "再次輸入新密碼",
            "type": "password",
            "name": "confirmation",
            "placeholder": "6 - 10 個英文加數字，需區分大小寫",
            "maxlength": "10",
            "required": ""
          },
          model: {
            value: _vm.confirmation,
            callback: function callback($$v) {
              _vm.confirmation = $$v;
            },
            expression: "confirmation"
          }
        })], 1), _c('button', {
          staticClass: "s-btn s-btn-primary s-mb-6",
          attrs: {
            "type": "submit",
            "disabled": !_vm.formIsValid || busy
          }
        }, [_vm._v(" 確定 ")]), _c('router-link', {
          staticClass: "s-btn s-btn-secondary",
          attrs: {
            "to": {
              name: 'LiffGroupBuyingAuthLogin',
              query: {
                mobile: _vm.mobileNumber
              }
            }
          }
        }, [_vm._v(" 回登入頁 ")])];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }